module.exports = "<input type=\"button\" class='btn btn-secondary' (click)=\"logout()\" value=\"Logout\" />"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/logout/logout.component.html
// module id = ./src/app/login/logout/logout.component.html
// module chunks = main